/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconOmega: {
  name: 'omega';
  data: string;
} = {
  name: 'omega',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M309.644 87.376c-123.738 0-224.537 107.621-224.537 240.909.001 51.008 14.668 98.998 39.761 137.997-29.215-15.818-57.911-34.973-86.54-58.474v113.685h208.945c-57.375-39.752-97.455-98.292-97.455-165.141 0-89.132 71.575-161.386 159.827-161.386s159.827 72.254 159.827 161.386c0 66.848-40.08 125.389-97.455 165.141h208.945V407.809c-28.712 23.746-57.728 43.27-87.32 59.253 25.455-39.171 40.542-87.367 40.542-138.777-.001-133.288-100.799-240.909-224.537-240.909h-.003z"/></svg>`,
};
